import { mxGraphSelectionModel, mxCell } from 'mxgraph-js';
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';

abstract class HCLMxGraphSelectionModel extends mxGraphSelectionModel {
  cellAdded(cell: mxCell) {
    super.cellAdded(cell);
  }


  isSelected(cell: mxCell): boolean {
    return super.isSelected(cell);
  }

  setCell(cell: mxCell) {
    if (!(cell instanceof HCLTreeVertex)) {
      super.setCell(cell);
      return;
    }
    const sameKeyVertices = cell.getGraph().getVerticesWithKey(cell.getKey());
    super.setCells(sameKeyVertices);
  }

  setCells(cells: mxCell[]) {
    super.setCells(cells);
  }

  getFirstSelectableCell(cells: mxCell[]): mxCell {
    return super.getFirstSelectableCell(cells);
  }

  addCell(cell: mxCell) {
    super.addCell(cell);
  }

  addCells(cells: mxCell[]) {
    super.addCells(cells);
  }

  removeCell(cell: mxCell) {
    super.removeCell(cell);
  }

  removeCells(cells: mxCell[]) {
    super.removeCells(cells);
  }

  changeSelection(added: mxCell[], removed: mxCell[]) {
    super.changeSelection(added, removed);
  }

  cellRemoved(cell: mxCell) {
    super.cellRemoved(cell);
  }
}

export default HCLMxGraphSelectionModel;
